export const mapB2CTenantToLanding = (tenantData) => ({
  isPreview:   tenantData?.isPreview ?? false,
  companyId:   tenantData?.companyId,
  branchId:    tenantData?.branchId,
  userId:      tenantData?.userId,
  logoUrl:     tenantData?.branding?.logoUrl     || '/assets/images/logo.png',
  brandName:   tenantData?.branding?.brandName   || 'Voyager',
  companyName: tenantData?.branding?.companyName || 'Voyager Travel',
  email:       tenantData?.branding?.email       || 'info@voyager.com',
  phones:      Array.isArray(tenantData?.branding?.phones)
               ? tenantData?.branding?.phones[0]
               : tenantData?.branding?.phones || '9000000000',
  whatsapp:    tenantData?.branding?.whatsapp || '9000000000',
  socials:     tenantData?.branding?.socials  || {},
  companyData: tenantData?.companyData        || {},
  seo:         tenantData?.seo               || {},
  themeColor1: tenantData?.theme?.themeColor1 || tenantData?.theme?.themecolor1,
  themeColor2: tenantData?.theme?.themeColor2 || tenantData?.theme?.themecolor2,
  themeColor3: tenantData?.theme?.themeColor3 || tenantData?.theme?.themecolor3,
  themeColor4: tenantData?.theme?.themeColor4 || tenantData?.theme?.themecolor4,
  themeColor5: tenantData?.theme?.themeColor5 || tenantData?.theme?.themecolor5,
  headerBgOverride:   tenantData?.header?.bgColor,
  headerTextOverride: tenantData?.header?.textColor,
  footerBgOverride:   tenantData?.footer?.bgColor,
  footerTextOverride: tenantData?.footer?.textColor,
  headingFont: tenantData?.branding?.headingFont || 'Playfair Display',
  bodyFont:    tenantData?.branding?.bodyFont    || 'DM Sans',
  heroData:    tenantData?.hero,
  aboutUs:     tenantData?.aboutUs,
  contactUs:   tenantData?.contactUs,
  activeModules: tenantData?.activeModules,
});

export const getB2CColors_T63 = (landingData) => {
  const saffron  = landingData?.themeColor1 || '#e8590c';
  const navy     = landingData?.themeColor2 || '#1a1a2e';
  const headerBg = landingData?.themeColor3 || '#ffffff';
  const gold     = landingData?.themeColor4 || '#f5a623';
  const pageBg   = landingData?.themeColor5 || '#fafaf5';

  return {
    theme1: saffron,
    theme2: landingData?.footerBgOverride || navy,
    theme3: landingData?.headerBgOverride || headerBg,
    theme4: gold,
    theme5: pageBg,
    saffron, gold, navy, pageBg,
    headerText: landingData?.headerTextOverride || '#1c1c1e',
    footerText: landingData?.footerTextOverride || '#cbd5e1',
  };
};

export const toRgba = (color, alpha = 1) => {
  if (!color || !color.startsWith('#')) return color;
  const hex = color.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
